import { Component,NgZone, AfterViewInit, Directive} from '@angular/core';
import { faGithub, faGitSquare, faNpm } from '@fortawesome/free-brands-svg-icons';
import {
  faBell,  faCode,
  faEnvelope, faLock, faTh, faUniversalAccess
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'trvapp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  version = '11.0.13';
 
  faGithub = faGithub;
  faGitSquare = faGitSquare;
  faNpm = faNpm;
  faUniversalAccess = faUniversalAccess;
  faCode = faCode;
  faEnvelope = faEnvelope;
  faLock = faLock;
  faTh = faTh;
  faBell = faBell;

  constructor(private ngZone: NgZone) {

    

   }
   ngAfterViewInit(): void {
    (document.querySelector('.menu-toggle .btn') as HTMLElement).style.display='none';
    (document.querySelector('.footer-container') as HTMLElement).style.marginTop='-20px';
  
  }
  
}